import AWS from "aws-sdk";
import { awsRegion, fileUploadPath, s3BUcketName } from "../constants";

const myBucket = new AWS.S3({
  params: { Bucket: s3BUcketName },
  region: awsRegion,
});

const useS3FileUpload = () => {
  const fileUpload = async (FileObjects, path, setUploadValues) => {
    const files = Array.isArray(FileObjects) ? FileObjects : [FileObjects];

    const council = JSON.parse(localStorage.getItem("council"));
    if (!council || !council.id) {
      throw new Error("Council ID is missing from localStorage.");
    }

    const uploadFileWithProgress = async (file, newFileName, onProgress) => {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        const formData = new FormData();

        formData.append("files[]", file, newFileName);

        xhr.open("POST", `${fileUploadPath}/api/v2/uploads`, true);
        xhr.setRequestHeader("COUNCIL_ID", council.id);

        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable) {
            const progress = Math.round((event.loaded / event.total) * 100);
            onProgress(progress);
          }
        };

        xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            resolve(JSON.parse(xhr.responseText));
          } else {
            reject(new Error(`Upload failed: ${xhr.statusText}`));
          }
        };

        xhr.onerror = () => reject(new Error("An error occurred while uploading the file"));
        xhr.send(formData);
      });
    };

    try {
      const results = await Promise.all(
        files.map((file) => {
          const newFileName = file.name.replace(/ /g, "_");
          return uploadFileWithProgress(file, newFileName, (progress) => {
            if (setUploadValues) {
              setUploadValues((uploadValues) => {
                return uploadValues.map((item) =>
                  item.name === newFileName
                    ? { ...item, progress }
                    : item
                )
              });
            }
          }).then((result) => {
            return {
              location: result.files[0]?.url,
              name: result.files[0]?.filename,
            };
          });
        })
      );

      return results[0];
    } catch (err) {
      console.error("Error uploading files:", err);
      if (setUploadValues) {
        setUploadValues((uploadValues) =>
          uploadValues.map((item) =>
            files.some((file) => {
              const newFileName = file.name.replace(/ /g, "_");
              return newFileName === item.name;
            })
              ? { ...item, progress: "FAILED" }
              : item
          )
        );
      }

      throw err;
    }
  };

  const fileDelete = async (file) => {
    const params = {
      Bucket: s3BUcketName,
      Key: file,
    };

    return new Promise((resolve) =>
      myBucket.deleteObject(params, (err, data) => {
        if (err) {
          resolve();
          throw err;
        }
        if (data) {
          resolve();
        }
      })
    );
  };
  return { fileUpload, fileDelete };
};

export default useS3FileUpload;
